import React from 'react'
import noop from 'lodash/noop'

import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import { ReactComponent as TableFilterIcon } from 'assets/TableFilterIcon.svg'
import { ReactComponent as TableFilterFilledIcon } from 'assets/TableFilterFilledIcon.svg'

type HHTableFilterProps = {
  isDisabled?: boolean
  isActive?: boolean
  onClick?: () => void
} & Omit<IconButtonProps, 'disabled' | 'onClick'>

const HHTableFilter = ({ isDisabled = false, isActive = false, onClick = noop, ...rest }: HHTableFilterProps) => (
  <IconButton disabled={isDisabled} onClick={onClick} {...rest}>
    {isActive ? <TableFilterFilledIcon /> : <TableFilterIcon />}
  </IconButton>
)

export default HHTableFilter
